import { atom } from 'recoil';
import { blankNotification } from '../interfaces/INotification';

const notificationAtom = atom({
  key: 'notificationState',
  default: blankNotification,
});

export default notificationAtom;
